import type { IntervalUnit, PartType, ServiceIntervalConfig } from '../../types';

// The unit a part's usage reads in: the configured interval's unit when one
// exists; otherwise the part's native unit (batteries count cycles, everything
// else hours).
export const getUsageUnit = ({
    interval,
    partType
}: {
    interval?: ServiceIntervalConfig;
    partType?: PartType;
}): IntervalUnit => interval?.unit ?? (partType === 'battery' ? 'cycles' : 'hours');
